export default __webpack_public_path__ + "static/media/tara1.e7c40a8a.png";